import React from 'react';

import { useRespondedYearToDateReport, useRespondedYearToDateReportCsv } from 'api';
import { useRespondedYearToDateFilters } from './hooks';
import { BaseReport } from '../..';

export const RespondedYearToDateReport: React.FC = () => {
  useRespondedYearToDateReport();
  const filters = useRespondedYearToDateFilters();
  const { mutate: exportCsv } = useRespondedYearToDateReportCsv();

  return <BaseReport filters={filters} exportCsv={exportCsv} />;
};
